import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'discount'
})
export class DiscountPipe implements PipeTransform {

  /**
   * Compat tema Multikart: el primer parámetro (valor antes del `|`) suele ignorarse;
   * el precio efectivo viene de `args.price` (producto).
   */
  transform(value: any, args?: any): any {
    const price = args?.price;
    if (price == null || Number.isNaN(Number(price))) {
      return value;
    }

    const dRaw = args?.discount;
    if (dRaw === undefined || dRaw === null || `${dRaw}` === '') {
      return price;
    }

    const d = Number(dRaw);
    if (Number.isNaN(d) || d === 0) {
      return price;
    }

    return Number(price) - (Number(price) * d / 100);
  }
}
